/** @see $bog_builderui_tokens */
namespace $ {
	$mol_style_define( $bog_builderui_avatar, {
		width: '40px',
		height: '40px',
		minWidth: '40px',
		border: {
			radius: '50%',
			width: '1px',
			style: 'solid',
			color: $bog_builderui_tokens.line,
		},
		background: {
			color: $bog_builderui_tokens.field,
		},
	} )
}
